module.exports = __webpack_public_path__ + "public/images/hand-and-heart.d7745d70ad7b94b249ffa9fba00bf7f8.png";